import React, { useState, useEffect, memo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import LogoImage from './Images/LogoImage.png';

const NavbarComponent = memo(({ darkMode, toggleMobileMenu, mobileMenuOpen, scrolled, isMobile }) => {
  const [activeLink, setActiveLink] = useState(window.location.pathname);
  const location = useLocation();

  useEffect(() => {
    setActiveLink(location.pathname);
  }, [location]);

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="logo">
        <Link to="/" onClick={() => setActiveLink('/')}>
          <img 
            src={LogoImage} 
            alt="Logo" 
          />
          <span>Miles Childress</span>
        </Link>
      </div>
      
      {/* Navigation Links - Only show on desktop */}
      {!isMobile && (
        <div className="nav-links">
          <Link 
            to="/" 
            className={`nav-link ${activeLink === '/' ? 'active' : ''}`}
            onClick={() => setActiveLink('/')}
          >
            Home
          </Link>
          <Link 
            to="/about" 
            className={`nav-link ${activeLink === '/about' ? 'active' : ''}`}
            onClick={() => setActiveLink('/about')}
          >
            About Me
          </Link>
          <Link 
            to="/portfolio" 
            className={`nav-link ${activeLink === '/portfolio' ? 'active' : ''}`}
            onClick={() => setActiveLink('/portfolio')}
          >
            Portfolio
          </Link>
          <Link
            to="/contact"
            className={`nav-link ${activeLink === '/contact' ? 'active' : ''}`}
            onClick={() => setActiveLink('/contact')}
          >
            Contact
          </Link>
          <a
            href={`${process.env.PUBLIC_URL}/Miles Childress MIS RESUME 2025.pdf`}
            target="_blank"
            rel="noopener noreferrer"
            download="Miles_Childress_Resume.pdf"
            className="nav-link-resume"
          >
            Resume
          </a>
        </div>
      )}
      
      {/* Hamburger Menu Button - Only show on mobile */}
      {isMobile && (
        <div className="mobile-menu-toggle" onClick={toggleMobileMenu}>
          <div style={{
            width: '25px',
            height: '2px',
            backgroundColor: '#fff',
            margin: '5px 0',
            transition: 'all 0.3s ease',
            transform: mobileMenuOpen ? 'rotate(45deg) translate(5px, 5px)' : 'none'
          }} />
          <div style={{
            width: '25px',
            height: '2px',
            backgroundColor: '#fff',
            margin: '5px 0',
            transition: 'all 0.3s ease',
            opacity: mobileMenuOpen ? 0 : 1
          }} />
          <div style={{
            width: '25px',
            height: '2px',
            backgroundColor: '#fff',
            margin: '5px 0',
            transition: 'all 0.3s ease',
            transform: mobileMenuOpen ? 'rotate(-45deg) translate(5px, -5px)' : 'none'
          }} />
        </div>
      )}
    </nav>
  );
});

export default NavbarComponent;
